import { ButtonProps, Button } from "@repo/ui/components/button";
import { Spinner } from "@repo/ui/components/spinner";
import React from "react";
export interface BusyButtonProps extends ButtonProps {
  busy?: boolean;
  disabled?: boolean;
  iconPosition?: "first" | "last";
  icon?: React.ReactNode;
  label?: React.ReactNode;
  busyLabel?: React.ReactNode;
}
const BusyButton = React.forwardRef<HTMLButtonElement, BusyButtonProps>(
  (
    {
      busy,
      icon,
      label,
      busyLabel,
      disabled,
      iconPosition = "first",
      ...props
    },
    ref
  ) => {
    return (
      <Button disabled={busy || disabled} ref={ref} {...props}>
        {iconPosition === "first" && (
          <>
            {busy ? (
              <Spinner color="currentColor" />
            ) : (
              icon
            )}
            {busy ? busyLabel : label}
          </>
        )}
        {iconPosition === "last" && (
          <>
            {busy ? busyLabel : label}
            {busy ? (
              <Spinner color="currentColor" />
            ) : (
              icon
            )}
          </>
        )}
      </Button>
    );
  }
);
BusyButton.displayName = "BusyButton";

export { BusyButton };
